export default class JSONParseError extends Error {
  constructor (public jsonString: string) {
    super('Failed to parse firehose response')
    this.name = 'JSONParseError'
    this.jsonString = jsonString
  }
}
